import { createStore } from "vuex";
import { auth } from "./auth.module";
import createPersistedState from "vuex-persistedstate";

const store = createStore({
  modules: {
    auth,
  },
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })],
});

export default store;
